/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable func-names */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-plusplus */
import React, { useState } from 'react'
import axios from 'axios'
import { Text, useToasts } from '@geist-ui/react'
import { useToken } from 'hooks'

export default function Upload({ account_id, claim_id }) {
  const [fileTooLarge, setFileTooLarge] = useState(false)
  const [isloading, setIsLoading] = useState(false)
  const [toast, setToast] = useToasts()
  const { headers } = useToken()

  const setFileExtension = (file_type) => {
    const types = {
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'image/jpg': 'jpg',
      'application/pdf': 'pdf',
      '': '',
    }
    return types[file_type]
  }

  const handleFile = async (e) => {
    setIsLoading(true)
    fileTooLarge && setFileTooLarge(false)

    const file = e.target.files[0]

    if (!file) {
      return
    }

    const files = Array.from(e.target.files)
    const TEN_MEGABYTES = 10485760

    const totalFileSize = files.reduce(
      (total, currentFile) => total + currentFile.size,
      0
    )

    if (totalFileSize > TEN_MEGABYTES) {
      setFileTooLarge(true)
      setIsLoading(false)
      return
    }

    const { type } = file
    const base64Reader = new FileReader()

    base64Reader.onload = async function (e) {
      const image = e.target.result

      const fileData = {
        account_id,
        claim_id,
        file_type: type,
      }

      await axios({
        method: 'post',
        url: `${process.env.NEXT_PUBLIC_API_URL}/upload`,
        headers,
        data: fileData,
      }).then((res) => {
        const url = res.data

        if (url === '') {
          setIsLoading(false)
          return
        }

        if (!image) {
          setIsLoading(false)
          return
        }

        const binary_formatted_image = atob(image.split(',')[1])
        const char_array = []
        for (let i = 0; i < binary_formatted_image.length; i++) {
          char_array.push(binary_formatted_image.charCodeAt(i))
        }
        const image_blob = new Blob([new Uint8Array(char_array)], {
          type,
        })

        axios({
          method: 'put',
          url,
          headers: { 'Content-Type': type },
          data: image_blob,
        })
          .then(() => {
            const file_type = setFileExtension(type)
            const update = {
              account_id,
              claim_id,
              claim_proof_filetype: file_type,
            }
            axios({
              method: 'put',
              url: `${process.env.NEXT_PUBLIC_API_URL}/claim`,
              headers,
              data: update,
            }).catch((err) => {
              setIsLoading(false)
              setToast({
                text: 'There was an error updating your claim information. Please contact support@waterproplan.',
                type: 'error',
                delay: 5000,
              })
            })
          })
          .then(() => {
            setIsLoading(false)
            setToast({
              text: 'Proof of repair successfully uploaded.',
              type: 'success',
              delay: 5000,
            })
          })
          .catch((err) => {
            setIsLoading(false)
            setToast({
              text: 'There was an error uploading your proof of repair. Please contact support@waterproplan.',
              type: 'error',
              delay: 5000,
            })
            return err
          })
      })
    }
    base64Reader.readAsDataURL(file)
  }

  return (
    <label>
      <Text
        p
        style={{
          margin: '0 0 .5rem',
          fontSize: '.9rem',
          opacity: '0.75',
        }}
      >
        Upload proof of repair{' '}
        <small style={{ opacity: '.6' }}>.jpg, .png, .pdf | 10MB max</small>
      </Text>
      <input type="file" accept=".pdf,.jpeg,.png" onChange={handleFile} />
      {fileTooLarge && (
        <p
          style={{
            fontSize: '14px',
            color: 'red',
          }}
        >
          Total file size cannot exceed 10MB
        </p>
      )}
    </label>
  )
}
